import React from 'react';
import { connect } from 'react-redux';
import FrmRegister from './FrmRegister';
import BankValidation from './BankValidation';

const Home = props => (
  <React.Fragment>
    <h2 className="py-3">Pendaftaran Nasabah</h2>
    <FrmRegister />
  </React.Fragment>
);

export default connect()(Home);



// WEBPACK FOOTER //
// ./src/components/Home.js